import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { useSelector } from 'react-redux';

import { UNREAD_STATUS } from '../../../shared/constants';
import { formatMessageHelper } from '../../../shared/helpers/internationalization';
import { activeTabStatusSelector } from '../../../reducers/GenericSelectors';

import './EditorTopBarRight.scss';
import classcat from 'classcat';

interface EditorTopBarRightProps {
  onClickCode: () => void;
  onClickResults: () => void;
  onClickLearn: () => void;
  onClickDataExplorer: () => void;
  onClickTutorial: () => void;
  code: boolean;
  results: boolean;
  learn: boolean;
  dataExplorer: boolean;
  isTutorialSelected: boolean;
  isTutorialAvailable?: boolean;
}

type EditorTopBarRightPropsGeneric = EditorTopBarRightProps & InjectedIntlProps;

interface FilterCheckboxProps {
  onClick: () => void;
  selected: boolean;
  title: string;
  isUnread?: boolean;
  className?: string;
}

const FilterCheckbox = ({ onClick, selected, title, isUnread, className }: FilterCheckboxProps) => (
  <div className={classcat([selected && 'editor__checkbox--selected', 'editor__checkbox', className])} onClick={onClick}>
    <div className="code-checkbox__block" />
    <div className="code-checkbox__label">
      <span>{title}</span>
    </div>
    {isUnread && (
      <div className="code-checkbox__unread">
        <div className="code-checkbox__unread--dot" />
      </div>
    )}
  </div>
);

const EditorTopBarRightIntl = ({
  onClickCode,
  onClickResults,
  onClickLearn,
  onClickDataExplorer,
  onClickTutorial,
  code,
  results,
  learn,
  dataExplorer,
  isTutorialSelected,
  isTutorialAvailable,
  intl,
}: EditorTopBarRightPropsGeneric) => {
  const { tabStatus } = useSelector(activeTabStatusSelector);
  const isUnreadResults = tabStatus === UNREAD_STATUS;

  return (
    <div className="editor-top-bar-right">
      <div className="editor-top-bar-right__filters">
        <FilterCheckbox onClick={onClickCode} selected={code} title={formatMessageHelper(intl, 'editorTopBarRight.code')} />
        <FilterCheckbox
          onClick={onClickResults}
          selected={results}
          title={formatMessageHelper(intl, 'editorTopBarRight.results')}
          isUnread={isUnreadResults}
          className="editor__checkbox-results"
        />
        <FilterCheckbox onClick={onClickLearn} selected={learn} title={formatMessageHelper(intl, 'editorTopBarRight.learn')} />
        <FilterCheckbox
          onClick={onClickDataExplorer}
          selected={dataExplorer}
          title={formatMessageHelper(intl, 'editorTopBarRight.dataExplorer')}
        />
        {isTutorialAvailable && (
          <FilterCheckbox
            onClick={onClickTutorial}
            selected={isTutorialSelected}
            title={formatMessageHelper(intl, 'editorTopBarRight.tutorial')}
          />
        )}
      </div>
    </div>
  );
};

export const EditorTopBarRight = injectIntl(EditorTopBarRightIntl);
